(function() {
  'use strict';

  /* ============================================================================
   * State and Utilities
   * ============================================================================ */
  const state = {
    cart: null
  };

  const utils = {
    formatMoney(cents, format = 'â‚¨ {{amount}}') {
      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }
      let value = '';
      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      const formatString = format || 'â‚¨ {{amount}}';

      function defaultOption(opt, def) {
        return (typeof opt === 'undefined' ? def : opt);
      }

      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 0);
        thousands = defaultOption(thousands, ',');
        decimal = defaultOption(decimal, '.');

        if (isNaN(number) || number == null) {
          return 0;
        }

        number = (number / 100.0).toFixed(precision);

        const parts = number.split('.');
        const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        const cents = parts[1] ? (decimal + parts[1]) : '';

        return dollars + cents;
      }

      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
      }

      return formatString.replace(placeholderRegex, value);
    },

    debounce(fn, wait) {
      let t;
      return function(...args) {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    },

    throttle(fn, wait) {
      let time = Date.now();
      return function() {
        if ((time + wait - Date.now()) < 0) {
          fn.apply(this, arguments);
          time = Date.now();
        }
      }
    }
  };

  /* ============================================================================
   * 1. Cart API Module (OfFixCart)
   * ============================================================================ */
  const OfFixCart = {
    getCart() {
      return fetch('/cart.js', {
        headers: { 'Accept': 'application/json' }
      })
      .then(res => res.json())
      .then(cart => {
        state.cart = cart;
        return cart;
      });
    },

    addItem(id, quantity = 1) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ id, quantity })
      })
      .then(res => {
        if (!res.ok) {
          return res.json().then(json => { throw json; });
        }
        return res.json();
      })
      .then(item => {
        return this.getCart().then(cart => {
          this.updateCartCount(cart.item_count);
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
          return item;
        });
      });
    },

    updateItem(line, quantity) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ line, quantity })
      })
      .then(res => res.json())
      .then(cart => {
        state.cart = cart;
        this.updateCartCount(cart.item_count);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
        return cart;
      });
    },

    removeItem(line) {
      return this.updateItem(line, 0);
    },

    clearCart() {
      return fetch('/cart/clear.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        }
      })
      .then(res => res.json())
      .then(cart => {
        state.cart = cart;
        this.updateCartCount(0);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
        return cart;
      });
    },

    updateCartCount(count) {
      const badges = document.querySelectorAll('[data-cart-count]');
      badges.forEach(badge => {
        badge.textContent = count;
        if (count === 0) {
          badge.setAttribute('data-cart-count', '0');
        } else {
          badge.setAttribute('data-cart-count', count.toString());
        }
      });
    },

    renderCartDrawer(cart) {
      const drawerBody = document.querySelector('[data-cart-drawer-body], [data-cart-items]');
      const drawerFooter = document.querySelector('[data-cart-drawer-footer]');
      const drawerEmpty = document.querySelector('[data-cart-empty]');

      if (!drawerBody) return;

      if (!cart || cart.item_count === 0) {
        drawerBody.classList.add('u-visually-hidden');
        if (drawerFooter) drawerFooter.classList.add('u-visually-hidden');
        if (drawerEmpty) drawerEmpty.classList.remove('u-visually-hidden');
        return;
      }

      drawerBody.classList.remove('u-visually-hidden');
      if (drawerFooter) drawerFooter.classList.remove('u-visually-hidden');
      if (drawerEmpty) drawerEmpty.classList.add('u-visually-hidden');

      drawerBody.innerHTML = '';
      
      cart.items.forEach((item, index) => {
        const line = index + 1;
        const html = `
          <div class="cart-drawer__item" data-cart-item data-line="${line}" data-variant-id="${item.variant_id}">
            <a href="${item.url}" class="cart-drawer__item-image">
              <img src="${item.image || ''}" alt="${item.title}" loading="lazy">
            </a>
            <div class="cart-drawer__item-info">
              <a href="${item.url}" class="cart-drawer__item-title">${item.product_title}</a>
              ${item.variant_title && item.variant_title !== 'Default Title' ? `<p class="cart-drawer__item-variant">${item.variant_title}</p>` : ''}
              <div class="cart-drawer__item-actions">
                <div class="quantity-selector" data-line-item-key="${item.key}" data-line="${line}">
                  <button type="button" class="quantity-selector__btn" data-action="decrease" aria-label="Decrease quantity">&minus;</button>
                  <input type="number" class="quantity-selector__input" name="updates[]" value="${item.quantity}" min="0" max="99" data-line="${line}">
                  <button type="button" class="quantity-selector__btn" data-action="increase" aria-label="Increase quantity">+</button>
                </div>
                <button type="button" class="cart-drawer__remove" data-action="remove-item" data-line="${line}" aria-label="Remove ${item.title}">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                </button>
              </div>
            </div>
          </div>
        `;
        drawerBody.insertAdjacentHTML('beforeend', html);
      });
    }
  };

  /* ============================================================================
   * 2. Cart Drawer Controller
   * ============================================================================ */
  const CartDrawer = {
    drawer: null,
    overlay: null,

    init() {
      this.drawer = document.querySelector('[data-cart-drawer]');
      if (!this.drawer) return;

      this.overlay = document.querySelector('[data-cart-drawer-overlay]');

      document.addEventListener('click', (e) => {
        if (e.target.closest('[data-action="open-cart"]')) {
          e.preventDefault();
          this.open();
        }
        if (e.target.closest('[data-action="close-cart"]')) {
          e.preventDefault();
          this.close();
        }
        if (e.target.closest('[data-cart-drawer-overlay]')) {
          this.close();
        }
        if (e.target.closest('[data-action="remove-item"]')) {
          const btn = e.target.closest('[data-action="remove-item"]');
          const line = btn.getAttribute('data-line');
          if (line) {
            btn.innerHTML = 'Removing...';
            btn.disabled = true;
            OfFixCart.removeItem(line);
          }
        }
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.drawer.getAttribute('aria-hidden') === 'false') {
          this.close();
        }
      });

      document.addEventListener('cart:updated', (e) => {
        OfFixCart.renderCartDrawer(e.detail.cart);
        this.fetchRecommendations(e.detail.cart);
      });
    },

    open() {
      if (!this.drawer) return;
      this.drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('cart-drawer-open');
      
      Accessibility.trapFocus(this.drawer);
      
      OfFixCart.getCart().then(cart => {
        OfFixCart.renderCartDrawer(cart);
        this.fetchRecommendations(cart);
      });
    },

    close() {
      if (!this.drawer) return;
      this.drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('cart-drawer-open');
      Accessibility.removeTrapFocus();
    },

    fetchRecommendations(cart) {
      const container = document.querySelector('[data-cart-recommendations]');
      if (!container || cart.item_count === 0) return;

      const firstItemProductId = cart.items[0].product_id;
      
      fetch(`/recommendations/products.json?product_id=${firstItemProductId}&limit=3`)
        .then(res => res.json())
        .then(({ products }) => {
          if (products && products.length > 0) {
            container.innerHTML = '<h3 class="cart-drawer__rec-title">You might also like</h3>';
            products.forEach(product => {
              const html = `
                <div class="cart-rec-item">
                  <a href="${product.url}" class="cart-rec-item__image">
                    <img src="${product.featured_image}" alt="${product.title}" loading="lazy">
                  </a>
                  <div class="cart-rec-item__info">
                    <a href="${product.url}" class="cart-rec-item__title">${product.title}</a>
                    
                    <button type="button" class="btn btn--secondary btn--small u-w-100 u-mt-2" data-action="add-rec" data-id="${product.variants[0].id}">Add</button>
                  </div>
                </div>
              `;
              container.insertAdjacentHTML('beforeend', html);
            });

            // Bind events for rec buttons
            const recBtns = container.querySelectorAll('[data-action="add-rec"]');
            recBtns.forEach(btn => {
              btn.addEventListener('click', (e) => {
                const id = btn.getAttribute('data-id');
                btn.textContent = 'Adding...';
                btn.disabled = true;
                OfFixCart.addItem(id, 1).catch(() => {
                  btn.textContent = 'Failed';
                  btn.disabled = false;
                });
              });
            });
          } else {
            container.innerHTML = '';
          }
        });
    }
  };

  /* ============================================================================
   * 3. Add to Cart Handler
   * ============================================================================ */
  const AddToCart = {
    init() {
      document.addEventListener('submit', (e) => {
        const form = e.target.closest('[data-product-form]');
        if (form) {
          e.preventDefault();
          
          const submitBtn = form.querySelector('[type="submit"]');
          const originalText = submitBtn.innerHTML;
          const errorMsg = form.querySelector('.form-error-message') || document.createElement('div');
          
          if (!errorMsg.classList.contains('form-error-message')) {
            errorMsg.className = 'form-error-message u-text-error u-mt-2 u-text-center';
            submitBtn.parentNode.insertBefore(errorMsg, submitBtn.nextSibling);
          }
          errorMsg.innerHTML = '';

          const idInput = form.querySelector('[name="id"]');
          const qtyInput = form.querySelector('[name="quantity"]');
          
          const variantId = idInput ? idInput.value : null;
          const quantity = qtyInput ? parseInt(qtyInput.value, 10) : 1;

          if (!variantId) return;

          submitBtn.disabled = true;
          submitBtn.innerHTML = 'Adding...';

          OfFixCart.addItem(variantId, quantity)
            .then(() => {
              submitBtn.innerHTML = originalText;
              submitBtn.disabled = false;
              Toast.show('Item added to Quote List');
              CartDrawer.open();
            })
            .catch(err => {
              submitBtn.innerHTML = originalText;
              submitBtn.disabled = false;
              errorMsg.textContent = err.description || 'This product is sold out or unavailable.';
            });
        }
      });
    }
  };

  /* ============================================================================
   * 4. Quantity Selector
   * ============================================================================ */
  const QuantitySelector = {
    init() {
      // Quantity range slider events
      document.addEventListener('input', (e) => {
        if (e.target.matches('[data-qty-range]')) {
          const slider = e.target;
          const container = slider.closest('[data-quantity-slider]');
          if (!container) return;
          const badge = container.querySelector('[data-qty-badge]');
          const input = container.querySelector('[data-quantity-input]');
          if (badge) badge.textContent = slider.value;
          if (input) {
            input.value = slider.value;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      });

      document.addEventListener('click', (e) => {
        if (e.target.closest('[data-action="slider-decrease"]')) {
          const btn = e.target.closest('[data-action="slider-decrease"]');
          const container = btn.closest('[data-quantity-slider]');
          if (!container) return;
          const slider = container.querySelector('[data-qty-range]');
          if (!slider) return;
          slider.value = Math.max(1, (parseInt(slider.value, 10) || 1) - 1);
          slider.dispatchEvent(new Event('input', { bubbles: true }));
        }
        if (e.target.closest('[data-action="slider-increase"]')) {
          const btn = e.target.closest('[data-action="slider-increase"]');
          const container = btn.closest('[data-quantity-slider]');
          if (!container) return;
          const slider = container.querySelector('[data-qty-range]');
          if (!slider) return;
          slider.value = Math.min(100, (parseInt(slider.value, 10) || 1) + 1);
          slider.dispatchEvent(new Event('input', { bubbles: true }));
        }
      });

      document.addEventListener('click', (e) => {
        const btn = e.target.closest('.quantity-selector__btn');
        if (!btn) return;

        const wrapper = btn.closest('.quantity-selector');
        const input = wrapper.querySelector('.quantity-selector__input');
        if (!input) return;

        let val = parseInt(input.value, 10) || 1;
        const action = btn.getAttribute('data-action');
        
        if (action === 'increase') {
          val = Math.min(val + 1, 99);
        } else if (action === 'decrease') {
          val = Math.max(val - 1, 1);
        }

        input.value = val;
        
        // Trigger change event to fire cart update if needed
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });

      // Handle direct input changes
      document.addEventListener('change', (e) => {
        if (e.target.classList.contains('quantity-selector__input')) {
          const input = e.target;
          const wrapper = input.closest('.quantity-selector');
          const lineItemKey = wrapper.getAttribute('data-line-item-key');
          const line = input.getAttribute('data-line');
          let val = parseInt(input.value, 10);
          
          if (isNaN(val) || val < 0) {
            val = 1;
            input.value = 1;
          }
          
          if (lineItemKey || line) {
            this.updateCartItem(line || lineItemKey, val);
          }
        }
      });
    },

    updateCartItem: utils.debounce((line, quantity) => {
      OfFixCart.updateItem(line, quantity);
    }, 300)
  };

  /* ============================================================================
   * 5. Sliding Pill Nav & Mega Menu
   * ============================================================================ */
  const PillNav = {
    init() {
      const list = document.querySelector('[data-nav-pill-list]');
      if (!list) return;

      const cursor = list.querySelector('[data-nav-pill-cursor]');
      const items = list.querySelectorAll('[data-nav-pill-item]');
      if (!cursor || !items.length) return;

      items.forEach(item => {
        item.addEventListener('mouseenter', () => {
          const itemRect = item.getBoundingClientRect();
          const listRect = list.getBoundingClientRect();
          const left = itemRect.left - listRect.left;
          
          cursor.style.opacity = '1';
          cursor.style.width = itemRect.width + 'px';
          cursor.style.transform = `translateX(${left}px)`;
        });
      });

      list.addEventListener('mouseleave', () => {
        cursor.style.opacity = '0';
      });
    }
  };

  /* ============================================================================
   * 5. Desktop Mega Menu & Dropdown Cards
   * ============================================================================ */
  const MegaMenu = {
    init() {
      const navItems = document.querySelectorAll('.header-nav__item--has-dropdown, [data-nav-item]');
      if (!navItems.length) return;

      const pageDim = document.querySelector('[data-header-dim]');
      let openTimeout = null;
      let closeTimeout = null;

      const closeAll = () => {
        clearTimeout(openTimeout);
        clearTimeout(closeTimeout);
        navItems.forEach(item => {
          item.classList.remove('is-open');
          const btn = item.querySelector('.header-nav__link');
          const panel = item.querySelector('[data-mega-panel]');
          if (btn) btn.setAttribute('aria-expanded', 'false');
          if (panel) {
            panel.classList.remove('is-open');
            panel.setAttribute('hidden', '');
          }
        });
        if (pageDim) pageDim.classList.remove('is-active');
      };

      const openItem = (item) => {
        clearTimeout(closeTimeout);
        clearTimeout(openTimeout);

        // Close other panels immediately
        navItems.forEach(other => {
          if (other !== item) {
            other.classList.remove('is-open');
            const otherBtn = other.querySelector('.header-nav__link');
            const otherPanel = other.querySelector('[data-mega-panel]');
            if (otherBtn) otherBtn.setAttribute('aria-expanded', 'false');
            if (otherPanel) {
              otherPanel.classList.remove('is-open');
              otherPanel.setAttribute('hidden', '');
            }
          }
        });

        item.classList.add('is-open');
        const btn = item.querySelector('.header-nav__link');
        const panel = item.querySelector('[data-mega-panel]');
        if (btn) btn.setAttribute('aria-expanded', 'true');
        if (panel) {
          panel.removeAttribute('hidden');
          void panel.offsetWidth;
          panel.classList.add('is-open');

          // Check if compact card overflows viewport
          if (panel.classList.contains('mega-panel--compact')) {
            const rect = panel.getBoundingClientRect();
            if (rect.right > window.innerWidth - 20) {
              panel.classList.add('mega-panel--align-right');
            } else {
              panel.classList.remove('mega-panel--align-right');
            }
          }
        }

        if (pageDim && panel && panel.classList.contains('mega-panel--full-width')) {
          pageDim.classList.add('is-active');
        }
      };

      navItems.forEach(item => {
        const btn = item.querySelector('.header-nav__link');
        const panel = item.querySelector('[data-mega-panel]');
        if (!panel) return;

        // Hover intent (120ms open delay)
        item.addEventListener('mouseenter', () => {
          if (window.innerWidth < 992) return;
          clearTimeout(closeTimeout);
          openTimeout = setTimeout(() => {
            openItem(item);
          }, 120);
        });

        // Grace delay (250ms close delay so moving down to panel never drops hover)
        item.addEventListener('mouseleave', () => {
          if (window.innerWidth < 992) return;
          clearTimeout(openTimeout);
          closeTimeout = setTimeout(() => {
            if (item.classList.contains('is-open')) {
              item.classList.remove('is-open');
              if (btn) btn.setAttribute('aria-expanded', 'false');
              panel.classList.remove('is-open');
              panel.setAttribute('hidden', '');
              if (pageDim) pageDim.classList.remove('is-active');
            }
          }, 250);
        });

        // Ensure hover on panel cancels closeTimeout and leaving starts grace delay
        panel.addEventListener('mouseenter', () => {
          if (window.innerWidth < 992) return;
          clearTimeout(closeTimeout);
        });

        panel.addEventListener('mouseleave', () => {
          if (window.innerWidth < 992) return;
          clearTimeout(openTimeout);
          closeTimeout = setTimeout(() => {
            if (item.classList.contains('is-open')) {
              item.classList.remove('is-open');
              if (btn) btn.setAttribute('aria-expanded', 'false');
              panel.classList.remove('is-open');
              panel.setAttribute('hidden', '');
              if (pageDim) pageDim.classList.remove('is-active');
            }
          }, 250);
        });

        // Click / Tap Toggle
        if (btn) {
          btn.addEventListener('click', (e) => {
            e.preventDefault();
            if (item.classList.contains('is-open')) {
              closeAll();
            } else {
              openItem(item);
            }
          });
        }

        // Close on clicking any link inside the panel
        const links = panel.querySelectorAll('a');
        links.forEach(link => {
          link.addEventListener('click', () => {
            closeAll();
          });
        });
      });

      // Close when clicking outside
      document.addEventListener('click', (e) => {
        if (!e.target.closest('.header-nav__item') && !e.target.closest('[data-mega-panel]')) {
          closeAll();
        }
      });

      // Keyboard Esc to dismiss and return focus
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          const openItemEl = document.querySelector('.header-nav__item.is-open');
          if (openItemEl) {
            const trigger = openItemEl.querySelector('.header-nav__link');
            closeAll();
            if (trigger) trigger.focus();
          }
        }
      });
    }
  };

  /* ============================================================================
   * 6. Mobile Navigation & Unified Accordions
   * ============================================================================ */
  const MobileNav = {
    init() {
      const nav = document.querySelector('[data-mobile-nav]');
      if (!nav) return;

      // Drawer Open / Close Toggle & Accordions
      document.addEventListener('click', (e) => {
        const toggleBtn = e.target.closest('[data-action="toggle-mobile-nav"]');
        if (toggleBtn) {
          e.preventDefault();
          if (nav.classList.contains('is-open')) {
            this.close(nav);
          } else {
            this.open(nav);
          }
          return;
        }

        if (e.target.closest('[data-action="close-mobile-nav"]')) {
          e.preventDefault();
          this.close(nav);
          return;
        }

        // Tapping background outside of interactive content
        if (nav.classList.contains('is-open') && e.target === nav) {
          e.preventDefault();
          this.close(nav);
          return;
        }

        // Mobile Accordion Toggle (One open at a time, smooth GPU transition)
        const accordionBtn = e.target.closest('[data-mobile-accordion]');
        if (accordionBtn) {
          e.preventDefault();
          const wrapper = accordionBtn.closest('.mobile-nav-menu__accordion-wrapper');
          const panel = wrapper ? wrapper.querySelector('.mobile-nav-menu__accordion-panel') : null;
          if (!panel) return;

          const isExpanded = accordionBtn.getAttribute('aria-expanded') === 'true';

          const resetGroupAccordions = (scope) => {
            if (!scope) return;
            scope.querySelectorAll('[data-mobile-group-accordion]').forEach(gBtn => {
              gBtn.setAttribute('aria-expanded', 'false');
              const gWrap = gBtn.closest('.mobile-nav-menu__group-wrapper');
              const gPanel = gWrap ? gWrap.querySelector('.mobile-nav-menu__group-panel') : null;
              if (gPanel) gPanel.classList.remove('is-expanded');
            });
          };

          // Close all other top-level accordions first (one open at a time) and reset their groups
          const allAccordionBtns = nav.querySelectorAll('[data-mobile-accordion]');
          allAccordionBtns.forEach(btn => {
            if (btn !== accordionBtn) {
              btn.setAttribute('aria-expanded', 'false');
              const otherWrapper = btn.closest('.mobile-nav-menu__accordion-wrapper');
              const otherPanel = otherWrapper ? otherWrapper.querySelector('.mobile-nav-menu__accordion-panel') : null;
              if (otherPanel) {
                otherPanel.classList.remove('is-expanded');
              }
              resetGroupAccordions(otherWrapper);
            }
          });

          // Toggle clicked accordion
          if (isExpanded) {
            accordionBtn.setAttribute('aria-expanded', 'false');
            panel.classList.remove('is-expanded');
            resetGroupAccordions(wrapper);
          } else {
            accordionBtn.setAttribute('aria-expanded', 'true');
            panel.classList.add('is-expanded');
          }
          return;
        }

        // Mobile Nested Sub-Group Accordion Toggle (Office & Domestic)
        const groupBtn = e.target.closest('[data-mobile-group-accordion]');
        if (groupBtn) {
          e.preventDefault();
          const groupWrapper = groupBtn.closest('.mobile-nav-menu__group-wrapper');
          const groupPanel = groupWrapper ? groupWrapper.querySelector('.mobile-nav-menu__group-panel') : null;
          if (!groupPanel) return;

          const isGroupExpanded = groupBtn.getAttribute('aria-expanded') === 'true';
          const parentAccordion = groupBtn.closest('.mobile-nav-menu__accordion-wrapper') || nav;

          // Mutual exclusivity: Close sibling group accordions inside this category
          const siblingGroupBtns = parentAccordion.querySelectorAll('[data-mobile-group-accordion]');
          siblingGroupBtns.forEach(btn => {
            if (btn !== groupBtn) {
              btn.setAttribute('aria-expanded', 'false');
              const otherWrap = btn.closest('.mobile-nav-menu__group-wrapper');
              const otherPan = otherWrap ? otherWrap.querySelector('.mobile-nav-menu__group-panel') : null;
              if (otherPan) otherPan.classList.remove('is-expanded');
            }
          });

          if (isGroupExpanded) {
            groupBtn.setAttribute('aria-expanded', 'false');
            groupPanel.classList.remove('is-expanded');
          } else {
            groupBtn.setAttribute('aria-expanded', 'true');
            groupPanel.classList.add('is-expanded');

            // Auto-scroll after opening: smooth scroll tapped row to ~16px below drawer top
            const scrollContainer = nav.querySelector('.mobile-nav-menu__inner') || nav;
            const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

            setTimeout(() => {
              const containerRect = scrollContainer.getBoundingClientRect();
              const btnRect = groupBtn.getBoundingClientRect();
              const offsetTop = btnRect.top - containerRect.top + scrollContainer.scrollTop;
              const targetScroll = Math.max(0, offsetTop - 16);

              scrollContainer.scrollTo({
                top: targetScroll,
                behavior: prefersReducedMotion ? 'instant' : 'smooth'
              });
            }, 60);
          }
          return;
        }
      });

      // Secondary image hover preload & detection for B2B product cards
      document.addEventListener('pointerenter', (e) => {
        const card = e.target && e.target.closest && e.target.closest('[data-product-card]');
        if (!card) return;
        const secondary = card.querySelector('.product-card__img--secondary');
        if (secondary) {
          if (secondary.complete && secondary.naturalWidth > 0) {
            const box = secondary.closest('.product-card__image-box');
            if (box) box.classList.add('has-loaded-secondary');
          } else {
            secondary.addEventListener('load', () => {
              const box = secondary.closest('.product-card__image-box');
              if (box) box.classList.add('has-loaded-secondary');
            }, { once: true });
          }
        }
      }, true);

      // Escape key closes mobile nav
      document.addEventListener('keydown', (e) => {
        if (!nav.classList.contains('is-open')) return;

        if (e.key === 'Escape') {
          e.preventDefault();
          this.close(nav);
          return;
        }

        // Keyboard Tab focus trapping
        if (e.key === 'Tab') {
          const focusables = Array.from(
            nav.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])')
          ).filter(el => el.offsetWidth > 0 || el.offsetHeight > 0);

          const toggleBtn = document.querySelector('[data-action="toggle-mobile-nav"]');
          if (toggleBtn) {
            focusables.unshift(toggleBtn);
          }

          if (focusables.length === 0) return;

          const firstFocusable = focusables[0];
          const lastFocusable = focusables[focusables.length - 1];

          if (e.shiftKey) {
            if (document.activeElement === firstFocusable) {
              e.preventDefault();
              lastFocusable.focus();
            }
          } else {
            if (document.activeElement === lastFocusable) {
              e.preventDefault();
              firstFocusable.focus();
            }
          }
        }
      });
    },

    open(nav) {
      nav.setAttribute('aria-hidden', 'false');
      nav.classList.add('is-open');
      document.body.classList.add('mobile-nav-open');
      document.documentElement.classList.add('mobile-nav-open');

      const toggleBtn = document.querySelector('[data-action="toggle-mobile-nav"]');
      if (toggleBtn) {
        toggleBtn.setAttribute('aria-expanded', 'true');
        toggleBtn.setAttribute('aria-label', 'Close mobile navigation menu');
        toggleBtn.classList.add('is-open');
      }

      // Move focus to first nav item smoothly after stagger entrance without scroll snapping
      setTimeout(() => {
        const firstLink = nav.querySelector('a, button');
        if (firstLink && typeof firstLink.focus === 'function') {
          firstLink.focus({ preventScroll: true });
        }
      }, 400);
    },

    close(nav) {
      nav.setAttribute('aria-hidden', 'true');
      nav.classList.remove('is-open');
      document.body.classList.remove('mobile-nav-open');
      document.documentElement.classList.remove('mobile-nav-open');

      const toggleBtn = document.querySelector('[data-action="toggle-mobile-nav"]');
      if (toggleBtn) {
        toggleBtn.setAttribute('aria-expanded', 'false');
        toggleBtn.setAttribute('aria-label', 'Open mobile navigation menu');
        toggleBtn.classList.remove('is-open');
        toggleBtn.focus();
      }
    }
  };

  /* ============================================================================
   * 6b. Mobile Filter Drawer
   * ============================================================================ */
  const FilterDrawer = {
    init() {
      const sidebar = document.querySelector('[data-filter-sidebar]');
      if (!sidebar) return;

      document.addEventListener('click', (e) => {
        if (e.target.closest('[data-action="toggle-mobile-filters"]')) {
          e.preventDefault();
          this.open(sidebar);
        }
        if (e.target.closest('[data-action="close-mobile-filters"]')) {
          e.preventDefault();
          this.close(sidebar);
        }
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && sidebar.getAttribute('aria-hidden') === 'false') {
          this.close(sidebar);
        }
      });
    },

    open(sidebar) {
      sidebar.setAttribute('aria-hidden', 'false');
      sidebar.classList.add('is-open');
      document.body.classList.add('filter-drawer-open');
    },

    close(sidebar) {
      sidebar.setAttribute('aria-hidden', 'true');
      sidebar.classList.remove('is-open');
      document.body.classList.remove('filter-drawer-open');
    }
  };

  /* ============================================================================
   * 6c. B2B Catalog AJAX Filter, Sorting & Density Module
   * ============================================================================ */
  const CatalogManager = {
    init() {
      const container = document.getElementById('ProductGridContainer');
      if (!container) return;

      this.bindDensity();
      this.bindFilters();
      this.bindSorting();
      this.bindPagination();
      this.bindPopState();
      this.restorePreferences();
    },

    bindDensity() {
      document.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-density]');
        if (!btn) return;
        e.preventDefault();
        const density = btn.getAttribute('data-density');
        this.setDensity(density);
      });
    },

    setDensity(density) {
      const grid = document.getElementById('CatalogProductsGrid');
      const densityBtns = document.querySelectorAll('[data-density]');
      if (!grid) return;

      grid.classList.remove('catalog-products-grid--cols-3', 'catalog-products-grid--cols-4');
      grid.classList.add('catalog-products-grid--cols-' + density);

      densityBtns.forEach(b => {
        if (b.getAttribute('data-density') === density) {
          b.classList.add('is-active');
        } else {
          b.classList.remove('is-active');
        }
      });

      try {
        localStorage.setItem('offix_catalog_density', density);
      } catch (err) {}
    },

    restorePreferences() {
      try {
        const savedDensity = localStorage.getItem('offix_catalog_density');
        if (savedDensity && (savedDensity === '3' || savedDensity === '4')) {
          this.setDensity(savedDensity);
        }
      } catch (err) {}
    },

    bindSorting() {
      document.addEventListener('change', (e) => {
        const sortSelect = e.target.closest('[data-sort-select]');
        if (!sortSelect) return;

        const currentUrl = new URL(window.location.href);
        currentUrl.searchParams.set('sort_by', sortSelect.value);
        currentUrl.searchParams.delete('page'); // Reset to page 1 on sort change
        this.fetchCatalog(currentUrl.toString());
      });
    },

    bindFilters() {
      // Checkbox changes inside filter form
      document.addEventListener('change', (e) => {
        const checkbox = e.target.closest('[data-filter-checkbox]');
        if (!checkbox) return;

        const form = checkbox.closest('form[data-filter-form]');
        if (!form) return;

        this.applyFormFilters(form);
      });

      // Active filter chip remove clicks, Clear all clicks, empty state clear clicks
      document.addEventListener('click', (e) => {
        const ajaxLink = e.target.closest('[data-ajax-filter-url]');
        if (!ajaxLink) return;

        e.preventDefault();
        const targetUrl = ajaxLink.getAttribute('data-ajax-filter-url') || ajaxLink.getAttribute('href');
        if (targetUrl) {
          this.fetchCatalog(targetUrl);
        }
      });
    },

    bindPagination() {
      document.addEventListener('click', (e) => {
        const pageLink = e.target.closest('#CatalogPaginationWrap a, .pagination-container a');
        if (!pageLink) return;

        const href = pageLink.getAttribute('href');
        if (!href || href === '#' || href.startsWith('javascript:')) return;

        e.preventDefault();
        this.fetchCatalog(href);
      });
    },

    applyFormFilters(form) {
      const formData = new FormData(form);
      const searchParams = new URLSearchParams();

      for (const [key, value] of formData.entries()) {
        if (value) {
          searchParams.append(key, value);
        }
      }

      const currentUrl = new URL(window.location.href);
      if (!searchParams.has('sort_by') && currentUrl.searchParams.has('sort_by')) {
        searchParams.set('sort_by', currentUrl.searchParams.get('sort_by'));
      }

      const action = form.getAttribute('action') || window.location.pathname;
      const targetUrl = action + (searchParams.toString() ? ('?' + searchParams.toString()) : '');
      this.fetchCatalog(targetUrl);
    },

    bindPopState() {
      window.addEventListener('popstate', (e) => {
        if (document.getElementById('ProductGridContainer')) {
          this.fetchCatalog(window.location.href, false);
        }
      });
    },

    fetchCatalog(url, updateHistory = true) {
      const main = document.getElementById('ProductGridMain');
      if (main) {
        main.classList.add('is-loading');
      }

      fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(response => {
          if (!response.ok) throw new Error('Network error loading catalog');
          return response.text();
        })
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');

          // 1. Update Main Product Area (Grid + Pagination or Empty state)
          const newMain = doc.getElementById('ProductGridMain');
          if (newMain && main) {
            main.innerHTML = newMain.innerHTML;
          }

          // 2. Update Product Count in Toolbar
          const newCount = doc.getElementById('CatalogProductCount');
          const currentCount = document.getElementById('CatalogProductCount');
          if (newCount && currentCount) {
            currentCount.innerHTML = newCount.innerHTML;
          }

          // 3. Update Toolbar Active Filter Chips
          const newActiveFilters = doc.querySelector('.catalog-toolbar__active-filters');
          const toolbarLeft = document.querySelector('.catalog-toolbar__left');
          const currentActiveFilters = document.querySelector('.catalog-toolbar__active-filters');

          if (newActiveFilters && toolbarLeft) {
            if (currentActiveFilters) {
              currentActiveFilters.replaceWith(newActiveFilters);
            } else {
              toolbarLeft.appendChild(newActiveFilters);
            }
          } else if (currentActiveFilters && !newActiveFilters) {
            currentActiveFilters.remove();
          }

          // 4. Update Filter Sidebar content while preserving open state of details
          const newSidebar = doc.getElementById('CatalogFilterSidebar');
          const currentSidebar = document.getElementById('CatalogFilterSidebar');
          if (newSidebar && currentSidebar) {
            const openIndexes = [];
            currentSidebar.querySelectorAll('details.product-filter-accordion').forEach((det, idx) => {
              if (det.open) openIndexes.push(idx);
            });

            const currentCard = currentSidebar.querySelector('.product-filter-card');
            const newCard = newSidebar.querySelector('.product-filter-card');
            if (currentCard && newCard) {
              currentCard.innerHTML = newCard.innerHTML;
            }

            currentSidebar.querySelectorAll('details.product-filter-accordion').forEach((det, idx) => {
              if (openIndexes.includes(idx)) {
                det.open = true;
              }
            });
          }

          // 5. Update mobile filter toggle badge count
          const newFilterBtn = doc.querySelector('.catalog-filter-toggle');
          const currentFilterBtn = document.querySelector('.catalog-filter-toggle');
          if (newFilterBtn && currentFilterBtn) {
            currentFilterBtn.innerHTML = newFilterBtn.innerHTML;
          }

          // 6. Update Sort select if needed
          const newSort = doc.getElementById('SortBy');
          const currentSort = document.getElementById('SortBy');
          if (newSort && currentSort) {
            currentSort.value = newSort.value;
          }

          // 7. Update History
          if (updateHistory) {
            window.history.pushState({ path: url }, '', url);
          }

          // 8. Re-apply density preference to new grid
          try {
            const savedDensity = localStorage.getItem('offix_catalog_density');
            if (savedDensity) {
              this.setDensity(savedDensity);
            }
          } catch (e) {}

          // 9. Re-trigger lazyload if exists
          if (typeof LazyLoad !== 'undefined' && LazyLoad.init) {
            LazyLoad.init();
          }

          // Scroll back up to catalog top smoothly if user scrolled down
          const container = document.getElementById('ProductGridContainer');
          if (container && window.scrollY > container.offsetTop + 100) {
            window.scrollTo({
              top: container.offsetTop - 60,
              behavior: 'smooth'
            });
          }
        })
        .catch(err => {
          console.error('Catalog AJAX error:', err);
          if (updateHistory) {
            window.location.href = url;
          }
        })
        .finally(() => {
          if (main) {
            main.classList.remove('is-loading');
          }
        });
    }
  };

  /* ============================================================================
   * 7. Announcement Bar Rotator
   * ============================================================================ */
  const AnnouncementBar = {
    init() {
      const bars = document.querySelectorAll('.announcement-bar');
      bars.forEach(bar => {
        const messages = bar.querySelectorAll('.announcement-bar__message');
        if (messages.length <= 1) return;

        const shouldRotate = bar.getAttribute('data-auto-rotate') === 'true';
        const speed = parseInt(bar.getAttribute('data-rotation-speed'), 10) || 5000;
        
        let currentIndex = 0;
        let interval;

        messages[0].classList.add('is-active');

        const nextSlide = () => {
          messages[currentIndex].classList.remove('is-active');
          currentIndex = (currentIndex + 1) % messages.length;
          messages[currentIndex].classList.add('is-active');
        };

        const start = () => {
          if (shouldRotate) {
            interval = setInterval(nextSlide, speed);
          }
        };

        const stop = () => {
          clearInterval(interval);
        };

        start();

        bar.addEventListener('mouseenter', stop);
        bar.addEventListener('mouseleave', start);
      });
    }
  };

  /* ============================================================================
   * 8. Sticky Header
   * ============================================================================ */
  const StickyHeader = {
    init() {
      // CSS position: sticky handles modern smooth pinning without startup jumps
      const header = document.querySelector('.section-header');
      if (!header) return;
      window.addEventListener('scroll', () => {
        if (window.scrollY > 40) {
          header.classList.add('is-scrolled');
        } else {
          header.classList.remove('is-scrolled');
        }
      }, { passive: true });
    }
  };

  /* ============================================================================
   * 9. Product Image Gallery (PDP)
   * ============================================================================ */
  const ProductGallery = {
    init() {
      const galleries = document.querySelectorAll('[data-product-gallery]');
      galleries.forEach(gallery => {
        const mainImage = gallery.querySelector('.product-detail__main-image img');
        const thumbnails = gallery.querySelectorAll('.product-detail__thumbnail');

        if (!mainImage) return;

        // Thumbnails
        thumbnails.forEach(thumb => {
          thumb.addEventListener('click', (e) => {
            e.preventDefault();
            const url = thumb.getAttribute('data-image-url');
            if (url) {
              mainImage.style.opacity = '0';
              setTimeout(() => {
                mainImage.src = url;
                mainImage.style.opacity = '1';
              }, 150);
              
              thumbnails.forEach(t => t.classList.remove('is-active'));
              thumb.classList.add('is-active');
            }
          });
        });

        // Hover Zoom
        const mainWrapper = gallery.querySelector('.product-detail__main-image');
        if (mainWrapper && window.innerWidth >= 990) {
          mainWrapper.addEventListener('mouseenter', () => {
            const fullUrl = mainImage.getAttribute('data-full-url') || mainImage.src;
            mainWrapper.style.backgroundImage = `url(${fullUrl})`;
            mainImage.style.opacity = '0';
          });
          
          mainWrapper.addEventListener('mousemove', (e) => {
            const rect = mainWrapper.getBoundingClientRect();
            const x = ((e.clientX - rect.left) / rect.width) * 100;
            const y = ((e.clientY - rect.top) / rect.height) * 100;
            mainWrapper.style.backgroundPosition = `${x}% ${y}%`;
          });

          mainWrapper.addEventListener('mouseleave', () => {
            mainWrapper.style.backgroundImage = 'none';
            mainImage.style.opacity = '1';
          });
        }
      });
    }
  };

  /* ============================================================================
   * 10. Variant Selector (PDP)
   * ============================================================================ */
  const VariantSelector = {
    init() {
      const forms = document.querySelectorAll('[data-product-form]');
      
      forms.forEach(form => {
        const productJsonScript = form.querySelector('[data-product-json]');
        if (!productJsonScript) return;

        let productData;
        try {
          productData = JSON.parse(productJsonScript.textContent);
        } catch(e) {
          return;
        }

        const optionInputs = form.querySelectorAll('.product-option__input');
        const idInput = form.querySelector('select[name="id"], input[name="id"]');
        const priceEl = form.querySelector('[data-product-price]');
        const submitBtn = form.querySelector('[type="submit"]');

        optionInputs.forEach(input => {
          input.addEventListener('change', () => {
            // Get currently selected options
            const selectedOptions = [];
            
            // Handle selects
            form.querySelectorAll('select.product-option__input').forEach(select => {
              selectedOptions.push(select.value);
            });
            
            // Handle radios
            form.querySelectorAll('input.product-option__input[type="radio"]:checked').forEach(radio => {
              selectedOptions.push(radio.value);
            });

            // Find variant
            const variant = productData.variants.find(v => {
              return v.options.every((val, index) => val === selectedOptions[index]);
            });

            if (variant) {
              if (idInput) idInput.value = variant.id;
              
              if (priceEl) {
                // Price suppressed for B2B
              }

              if (variant.available) {
                submitBtn.disabled = false;
                submitBtn.textContent = 'Add to Quote List';
              } else {
                submitBtn.disabled = true;
                submitBtn.textContent = 'Unavailable';
              }

              // Update URL
              if (history.replaceState) {
                const newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
                window.history.replaceState({path:newurl}, '', newurl);
              }

              // Update image if variant has featured image
              if (variant.featured_image) {
                const gallery = document.querySelector('[data-product-gallery]');
                if (gallery) {
                  const mainImage = gallery.querySelector('.product-detail__main-image img');
                  const thumb = gallery.querySelector(`.product-detail__thumbnail[data-image-id="${variant.featured_image.id}"]`);
                  if (mainImage) mainImage.src = variant.featured_image.src;
                  if (thumb) thumb.click();
                }
              }

            } else {
              submitBtn.disabled = true;
              submitBtn.textContent = 'Unavailable';
            }

            // Update labels
            const optionLabels = form.querySelectorAll('[data-selected-option]');
            optionLabels.forEach((label, i) => {
              if (selectedOptions[i]) {
                label.textContent = selectedOptions[i];
              }
            });
          });
        });
      });
    }
  };

  /* ============================================================================
   * 11. Search Overlay
   * ============================================================================ */
  const SearchOverlay = {
    init() {
      const overlay = document.querySelector('[data-search-overlay]');
      if (!overlay) return;

      const input = overlay.querySelector('input[type="search"]');

      document.addEventListener('click', (e) => {
        if (e.target.closest('[data-action="toggle-search"]')) {
          e.preventDefault();
          this.toggle(overlay, input);
        }
        if (e.target.closest('[data-action="close-search"]')) {
          e.preventDefault();
          this.close(overlay);
        }
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && overlay.getAttribute('hidden') == null) {
          this.close(overlay);
        }
      });
    },

    toggle(overlay, input) {
      if (overlay.hasAttribute('hidden')) {
        this.open(overlay, input);
      } else {
        this.close(overlay);
      }
    },

    open(overlay, input) {
      overlay.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
      Accessibility.trapFocus(overlay);
      if (input) {
        setTimeout(() => input.focus(), 100);
      }
    },

    close(overlay) {
      overlay.setAttribute('hidden', '');
      document.body.style.overflow = '';
      Accessibility.removeTrapFocus();
    }
  };

  /* ============================================================================
   * 12. SEO Content Toggle
   * ============================================================================ */
  const SeoContent = {
    init() {
      const sections = document.querySelectorAll('[data-section-type="seo-content"]');
      sections.forEach(section => {
        const toggleBtn = section.querySelector('[data-action="toggle-seo"], [data-action="toggle-content"], .seo-content__toggle');
        const content = section.querySelector('.seo-content__inner--collapsible, .seo-content__inner');
        
        if (toggleBtn && content) {
          toggleBtn.addEventListener('click', (e) => {
            e.preventDefault();
            const isExpanded = content.classList.contains('is-expanded');
            const textSpan = toggleBtn.querySelector('.seo-content__toggle-text');
            
            if (isExpanded) {
              content.style.maxHeight = content.scrollHeight + 'px';
              // Force reflow
              content.offsetHeight;
              content.style.maxHeight = '96px';
              content.classList.remove('is-expanded');
              toggleBtn.setAttribute('aria-expanded', 'false');
              if (textSpan) {
                textSpan.textContent = 'Read more';
              } else {
                toggleBtn.textContent = 'Read more';
              }
            } else {
              content.style.maxHeight = content.scrollHeight + 'px';
              content.classList.add('is-expanded');
              toggleBtn.setAttribute('aria-expanded', 'true');
              if (textSpan) {
                textSpan.textContent = 'Show less';
              } else {
                toggleBtn.textContent = 'Show less';
              }
              
              const onTransitionEnd = () => {
                if (content.classList.contains('is-expanded')) {
                  content.style.maxHeight = 'none';
                }
                content.removeEventListener('transitionend', onTransitionEnd);
              };
              content.addEventListener('transitionend', onTransitionEnd);
            }
          });
        }
      });
    }
  };

  /* ============================================================================
   * 13. Hero Banner Slider
   * ============================================================================ */
  const HeroSlider = {
    init() {
      const sliders = document.querySelectorAll('[data-section-type="hero-banner"]');
      
      sliders.forEach(slider => {
        const slides = slider.querySelectorAll('.hero-slide');
        if (slides.length <= 1) return;

        const autoPlay = slider.getAttribute('data-auto-play') === 'true';
        const duration = parseInt(slider.getAttribute('data-slide-duration'), 10) * 1000 || 5000;
        let currentIndex = 0;
        let interval;

        // Init first slide
        slides.forEach(s => s.style.opacity = '0');
        slides[0].style.opacity = '1';
        slides[0].classList.add('is-active');

        // Dots
        const dotsContainer = slider.querySelector('.hero-slider__dots');
        let dots = [];
        if (dotsContainer) {
          slides.forEach((s, i) => {
            const dot = document.createElement('button');
            dot.className = 'hero-slider__dot';
            if (i === 0) dot.classList.add('is-active');
            dot.setAttribute('aria-label', `Go to slide ${i+1}`);
            dot.addEventListener('click', () => goToSlide(i));
            dotsContainer.appendChild(dot);
            dots.push(dot);
          });
        }

        const goToSlide = (index) => {
          slides[currentIndex].style.opacity = '0';
          slides[currentIndex].classList.remove('is-active');
          if (dots[currentIndex]) dots[currentIndex].classList.remove('is-active');

          currentIndex = index;

          slides[currentIndex].style.opacity = '1';
          slides[currentIndex].classList.add('is-active');
          if (dots[currentIndex]) dots[currentIndex].classList.add('is-active');
        };

        const nextSlide = () => {
          goToSlide((currentIndex + 1) % slides.length);
        };

        const prevSlide = () => {
          goToSlide((currentIndex - 1 + slides.length) % slides.length);
        };

        const start = () => {
          if (autoPlay) interval = setInterval(nextSlide, duration);
        };

        const stop = () => {
          clearInterval(interval);
        };

        start();

        slider.addEventListener('mouseenter', stop);
        slider.addEventListener('mouseleave', start);

        // Touch events
        let startX = 0;
        slider.addEventListener('touchstart', (e) => {
          startX = e.touches[0].clientX;
          stop();
        }, { passive: true });
        
        slider.addEventListener('touchend', (e) => {
          const endX = e.changedTouches[0].clientX;
          if (startX - endX > 50) nextSlide();
          else if (startX - endX < -50) prevSlide();
          start();
        });
      });
    }
  };

  /* ============================================================================
   * 14. Product Carousel
   * ============================================================================ */
  const ProductCarousel = {
    init() {
      const carousels = document.querySelectorAll('[data-carousel]');
      
      carousels.forEach(wrapper => {
        const track = wrapper.querySelector('.carousel__track');
        const prevBtn = wrapper.querySelector('[data-action="prev"]');
        const nextBtn = wrapper.querySelector('[data-action="next"]');

        if (!track || !prevBtn || !nextBtn) return;

        const updateButtons = () => {
          const maxScrollLeft = track.scrollWidth - track.clientWidth;
          prevBtn.disabled = track.scrollLeft <= 0;
          nextBtn.disabled = track.scrollLeft >= maxScrollLeft - 1;
        };

        const scroll = (direction) => {
          const itemWidth = track.querySelector('.carousel__item').offsetWidth;
          const gap = parseFloat(getComputedStyle(track).gap) || 0;
          const scrollAmount = itemWidth + gap;

          track.scrollBy({
            left: direction === 'next' ? scrollAmount : -scrollAmount,
            behavior: 'smooth'
          });
        };

        prevBtn.addEventListener('click', () => scroll('prev'));
        nextBtn.addEventListener('click', () => scroll('next'));
        track.addEventListener('scroll', utils.debounce(updateButtons, 100));

        // Initial check
        updateButtons();
      });
    }
  };

  /* ============================================================================
   * 15. Product Recommendations (PDP)
   * ============================================================================ */
  const Recommendations = {
    init() {
      const container = document.querySelector('[data-product-recommendations]');
      if (!container) return;

      const url = container.getAttribute('data-url');
      if (!url) return;

      fetch(url)
        .then(res => res.text())
        .then(text => {
          const parser = new DOMParser();
          const html = parser.parseFromString(text, 'text/html');
          const recommendations = html.querySelector('[data-product-recommendations]');
          
          if (recommendations && recommendations.innerHTML.trim().length) {
            container.innerHTML = recommendations.innerHTML;
            // Re-initialize carousels within recs if needed
            ProductCarousel.init();
          } else {
            container.style.display = 'none';
          }
        });
    }
  };

  /* ============================================================================
   * 16. Footer Accordion (Mobile)
   * ============================================================================ */
  const FooterAccordion = {
    init() {
      const headings = document.querySelectorAll('.footer-column__heading');
      
      headings.forEach(heading => {
        heading.addEventListener('click', () => {
          if (window.innerWidth >= 750) return;

          const content = heading.nextElementSibling;
          const isExpanded = heading.getAttribute('aria-expanded') === 'true';

          heading.setAttribute('aria-expanded', !isExpanded);
          
          if (!isExpanded) {
            content.style.display = 'block';
            content.style.maxHeight = content.scrollHeight + 'px';
          } else {
            content.style.maxHeight = '0';
            setTimeout(() => { content.style.display = 'none'; }, 300);
          }
        });
      });
    }
  };

  /* ============================================================================
   * 17. Newsletter Form
   * ============================================================================ */
  const Newsletter = {
    init() {
      const forms = document.querySelectorAll('.newsletter-form');
      
      forms.forEach(form => {
        form.addEventListener('submit', (e) => {
          const emailInput = form.querySelector('input[type="email"]');
          if (emailInput && !emailInput.value.includes('@')) {
            e.preventDefault();
            alert('Please enter a valid email address.');
          }
          // Shopify handles the actual submission via standard POST
        });
      });
    }
  };

  /* ============================================================================
   * 18. Lazy Loading
   * ============================================================================ */
  const LazyLoad = {
    init() {
      if ('loading' in HTMLImageElement.prototype) {
        // Browser supports native lazy loading
        return;
      }

      // Fallback Intersection Observer
      const images = document.querySelectorAll('img[loading="lazy"]');
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries, observer) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              const img = entry.target;
              if (img.dataset.src) {
                img.src = img.dataset.src;
                img.removeAttribute('data-src');
              }
              observer.unobserve(img);
            }
          });
        });
        images.forEach(img => observer.observe(img));
      }
    }
  };

  /* ============================================================================
   * 19. Accessibility
   * ============================================================================ */
  const Accessibility = {
    focusableElementsString: 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex="0"], [contenteditable]',
    trapNode: null,
    
    init() {
      // Skip to main content
      const skipLink = document.querySelector('.skip-to-content');
      const mainContent = document.getElementById('MainContent');
      
      if (skipLink && mainContent) {
        skipLink.addEventListener('click', (e) => {
          e.preventDefault();
          mainContent.setAttribute('tabindex', '-1');
          mainContent.focus();
        });
      }
    },

    trapFocus(container) {
      this.trapNode = container;
      const focusableElements = Array.from(container.querySelectorAll(this.focusableElementsString)).filter(
        el => el.offsetWidth > 0 || el.offsetHeight > 0 || el === document.activeElement
      );

      if (focusableElements.length === 0) return;

      const firstFocusableEl = focusableElements[0];
      const lastFocusableEl = focusableElements[focusableElements.length - 1];

      firstFocusableEl.focus();

      container.addEventListener('keydown', this.handleFocus);
    },

    removeTrapFocus() {
      if (this.trapNode) {
        this.trapNode.removeEventListener('keydown', this.handleFocus);
        this.trapNode = null;
      }
    },

    handleFocus(e) {
      const isTabPressed = e.key === 'Tab' || e.keyCode === 9;

      if (!isTabPressed || !Accessibility.trapNode) {
        return;
      }

      const focusableElements = Array.from(Accessibility.trapNode.querySelectorAll(Accessibility.focusableElementsString)).filter(
        el => el.offsetWidth > 0 || el.offsetHeight > 0 || el === document.activeElement
      );
      
      const firstFocusableEl = focusableElements[0];
      const lastFocusableEl = focusableElements[focusableElements.length - 1];

      if (e.shiftKey) {
        if (document.activeElement === firstFocusableEl) {
          lastFocusableEl.focus();
          e.preventDefault();
        }
      } else {
        if (document.activeElement === lastFocusableEl) {
          firstFocusableEl.focus();
          e.preventDefault();
        }
      }
    }
  };

  /* ============================================================================
   * 20. Addresses Page (Customer Account)
   * ============================================================================ */
  const Addresses = {
    init() {
      const addressesContainer = document.querySelector('[data-customer-addresses]');
      if (!addressesContainer) return;

      // Toggle new address form
      const newAddressToggle = document.querySelector('[data-action="toggle-new-address"]');
      const newAddressForm = document.querySelector('#AddressNewForm');
      
      if (newAddressToggle && newAddressForm) {
        newAddressToggle.addEventListener('click', () => {
          newAddressForm.classList.toggle('u-hidden');
        });
      }

      // Toggle edit forms
      document.addEventListener('click', (e) => {
        if (e.target.closest('[data-action="toggle-edit-address"]')) {
          const btn = e.target.closest('[data-action="toggle-edit-address"]');
          const id = btn.getAttribute('data-form-id');
          const form = document.getElementById('EditAddress_' + id);
          if (form) {
            form.classList.toggle('u-hidden');
          }
        }
      });

      // Country/Province Selector logic is typically handled by Shopify's common.js
      // But if we need vanilla JS implementation:
      const countrySelectors = document.querySelectorAll('select[data-address-country-select]');
      countrySelectors.forEach(select => {
        select.addEventListener('change', (e) => {
          const provinceSelectorId = e.target.getAttribute('data-target');
          const provinceSelector = document.getElementById(provinceSelectorId);
          const provinceContainer = provinceSelector ? provinceSelector.parentNode : null;
          
          if (!provinceSelector) return;

          const options = e.target.options[e.target.selectedIndex];
          const rawProvinces = options.getAttribute('data-provinces');
          let provinces = [];
          
          try {
            provinces = JSON.parse(rawProvinces || '[]');
          } catch(err) {
            provinces = [];
          }

          provinceSelector.innerHTML = '';
          
          if (provinces.length === 0) {
            provinceContainer.style.display = 'none';
          } else {
            provinces.forEach(p => {
              const opt = document.createElement('option');
              opt.value = p[0];
              opt.textContent = p[1];
              provinceSelector.appendChild(opt);
            });
            provinceContainer.style.display = 'block';
          }
        });
        
        // Trigger on load
        select.dispatchEvent(new Event('change'));
      });
    }
  };
  /* ============================================================================
   * 17. Client Logos Scroll Entrance
   * ============================================================================ */
  const ClientLogos = {
    init() {
      const sections = document.querySelectorAll('.section-client-logos');
      if (!sections.length) return;

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries, obs) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              obs.unobserve(entry.target);
            }
          });
        }, { threshold: 0.15 });

        sections.forEach(sec => observer.observe(sec));
      } else {
        sections.forEach(sec => sec.classList.add('is-visible'));
      }
    }
  };

  /* ============================================================================
   * 18. Showroom Callout (Gallery & Live Hours Status)
   * ============================================================================ */
  const ShowroomCallout = {
    init() {
      // 1. Live Operating Hours (Pakistan Standard Time UTC+5)
      const badge = document.querySelector('[data-showroom-live-status]');
      if (badge) {
        const now = new Date();
        const utc = now.getTime() + (now.getTimezoneOffset() * 60000);
        const pktTime = new Date(utc + (3600000 * 5));
        const day = pktTime.getDay(); // 0 = Sunday, 1 = Monday, ..., 6 = Saturday
        const hour = pktTime.getHours(); // 0..23

        // Open Mon-Sat 10:00 AM - 8:00 PM (10:00 to 20:00)
        const isOpen = (day >= 1 && day <= 6) && (hour >= 10 && hour < 20);
        const textSpan = badge.querySelector('.status-badge__text');

        if (isOpen) {
          badge.className = 'showroom-status-badge showroom-status-badge--open';
          if (textSpan) textSpan.textContent = 'Open Now';
        } else {
          badge.className = 'showroom-status-badge showroom-status-badge--closed';
          if (textSpan) textSpan.textContent = 'Closed';
        }
      }

      // 2. Multi-Image Crossfade Gallery
      const gallery = document.querySelector('[data-showroom-gallery]');
      if (gallery) {
        const slides = gallery.querySelectorAll('.showroom-gallery__slide');
        const dots = gallery.querySelectorAll('.gallery-dot');
        if (slides.length <= 1) return;

        let currentIndex = 0;
        let timer = null;

        const showSlide = (index) => {
          slides.forEach((s, i) => s.classList.toggle('is-active', i === index));
          dots.forEach((d, i) => d.classList.toggle('is-active', i === index));
          currentIndex = index;
        };

        const startAutoplay = () => {
          stopAutoplay();
          timer = setInterval(() => {
            showSlide((currentIndex + 1) % slides.length);
          }, 3500);
        };

        const stopAutoplay = () => {
          if (timer) clearInterval(timer);
        };

        dots.forEach((dot, i) => {
          dot.addEventListener('click', () => {
            showSlide(i);
            startAutoplay();
          });
        });

        gallery.addEventListener('mouseenter', stopAutoplay);
        gallery.addEventListener('mouseleave', startAutoplay);

        startAutoplay();
      }
    }
  };

    /* ============================================================================
   * Toast Notification
   * ============================================================================ */
  const Toast = {
    show(message = 'Added to quote list') {
      let el = document.querySelector('.quote-toast');
      if (!el) {
        el = document.createElement('div');
        el.className = 'quote-toast';
        document.body.appendChild(el);
      }
      el.innerHTML = `<span class="quote-toast__icon">&#10003;</span> <span>${message}</span>`;
      el.classList.add('is-active');
      setTimeout(() => {
        el.classList.remove('is-active');
      }, 3000);
    }
  };

  /* ============================================================================
   * WhatsApp Quote Controller
   * ============================================================================ */
  const WhatsAppQuote = {
    init() {
      document.addEventListener('click', (e) => {
        if (e.target.closest('[data-action="whatsapp-quote"]')) {
          e.preventDefault();
          this.generateQuote();
        }
        if (e.target.closest('[data-action="clear-quote-list"]')) {
          e.preventDefault();
          this.clearQuoteList();
        }
      });
    },

    generateQuote() {
      OfFixCart.getCart().then(cart => {
        if (!cart.items || cart.items.length === 0) {
          alert('Your quote list is empty. Please add items to request a quote.');
          return;
        }

        const phone = (window.themeSettings && window.themeSettings.whatsappNumber) 
          ? window.themeSettings.whatsappNumber.replace(/[^0-9]/g, '') 
          : '923225545791';

        const origin = (window.themeSettings && window.themeSettings.shopOrigin) 
          ? window.themeSettings.shopOrigin 
          : window.location.origin;

        let msg = `*OFFIX B2B Quote Request*\n\nHello OFFIX Team,\nI would like to request an official quotation for the following items:\n\n`;

        cart.items.forEach((item, index) => {
          const variant = (item.variant_title && item.variant_title !== 'Default Title') ? ` (${item.variant_title})` : '';
          msg += `${index + 1}. *${item.product_title}*${variant}\n   â€¢ Quantity: *${item.quantity} units*\n   â€¢ Product Link: ${origin}${item.url}\n\n`;
        });

        const noteInput = document.querySelector('#CartNote, [name="note"]');
        const note = (noteInput && noteInput.value.trim()) || cart.note;
        if (note) {
          msg += `*Special Requirements / Notes:*\n${note}\n\n`;
        }

        msg += `Please provide pricing, bulk discounts, and estimated delivery timeline.\nThank you!`;

        const waUrl = `https://wa.me/${phone}?text=${encodeURIComponent(msg)}`;
        window.open(waUrl, '_blank');

        setTimeout(() => {
          if (confirm('Quote request opened in WhatsApp! Would you like to clear your quote list now?')) {
            OfFixCart.clearCart().then(() => {
              if (window.location.pathname.includes('/cart')) {
                window.location.reload();
              }
            });
          }
        }, 1000);
      });
    },

    clearQuoteList() {
      if (confirm('Are you sure you want to clear your quote list?')) {
        OfFixCart.clearCart().then(() => {
          if (window.location.pathname.includes('/cart')) {
            window.location.reload();
          }
        });
      }
    }
  };

  /* ============================================================================
   * Initialize All
   * ============================================================================ */
  
  /* Card Range Slider and Demo Quote button handling */
  document.addEventListener('input', function(e) {
    if (e.target && e.target.type === 'range') {
      var row = e.target.closest('[data-card-slider], [data-quote-qty-slider], [data-quantity-slider], .product-card__slider-row, .quote-quantity-slider');
      if (row) {
        var badge = row.querySelector('.product-card__qty-badge, .quote-quantity-slider__badge, [data-qty-badge]');
        if (badge && badge.textContent && badge.textContent.includes('Translation')) {
          badge.innerHTML = 'Qty: <strong data-slider-val data-qty-value>' + e.target.value + '</strong>';
        } else {
          var readouts = row.querySelectorAll('[data-slider-val], [data-qty-value], [data-qty-badge], strong');
          readouts.forEach(function(r) { r.textContent = e.target.value; });
        }
      }
      var card = e.target.closest('[data-product-card], .product-card');
      if (card) card.setAttribute('data-selected-qty', e.target.value);
    }
  });

  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-action="add-demo-to-quote"]');
    if (btn) {
      e.preventDefault();
      var card = btn.closest('[data-product-card]');
      var title = btn.getAttribute('data-title') || 'Office Furniture Model';
      var slider = card ? card.querySelector('[data-slider-input]') : null;
      var qty = slider ? slider.value : '5';
      
      // Open quote drawer and trigger toast
      if (typeof Toast !== 'undefined') {
        Toast.show(title + ' (Qty: ' + qty + ') added to Quote List');
      }
      if (typeof CartDrawer !== 'undefined') {
        CartDrawer.open();
      }
    }
  });

  /* ============================================================================
   * 21. Home Interactivity (Scroll Stagger & Testimonials Carousel)
   * ============================================================================ */
  const HomeInteractivity = {
    carouselTimer: null,
    currentSlide: 0,
    totalSlides: 3,

    init() {
      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      
      const targets = document.querySelectorAll(
        '.shop-category__grid, .section-featured-products .product-grid, .section-featured-products .catalog-products-grid, .why-offix-grid, .testimonials-grid, .showroom-split'
      );

      if (prefersReducedMotion) {
        targets.forEach(el => el.classList.add('is-visible'));
        this.initTestimonialsCarousel(true);
        return;
      }

      // 1. Scroll-triggered entrance animations via IntersectionObserver
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries, obs) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              obs.unobserve(entry.target);
            }
          });
        }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

        targets.forEach(el => observer.observe(el));
      } else {
        targets.forEach(el => el.classList.add('is-visible'));
      }

      // 2. Initialize Testimonials Carousel
      this.initTestimonialsCarousel(false);
    },

    initTestimonialsCarousel(reducedMotion) {
      const carousel = document.querySelector('[data-testimonials-carousel]');
      if (!carousel) return;

      const track = carousel.querySelector('[data-testimonials-track]');
      const cards = carousel.querySelectorAll('[data-testimonial-card]');
      const prevBtn = carousel.querySelector('[data-carousel-prev]');
      const nextBtn = carousel.querySelector('[data-carousel-next]');
      const dots = carousel.querySelectorAll('[data-carousel-dot]');

      if (!track || !cards.length) return;
      this.totalSlides = cards.length;

      const updateSlide = (index) => {
        if (index < 0) index = this.totalSlides - 1;
        if (index >= this.totalSlides) index = 0;
        this.currentSlide = index;

        // On mobile/tablet, slide track horizontally
        if (window.innerWidth < 990) {
          track.style.transform = 'translateX(-' + (index * 100) + '%)';
        } else {
          track.style.transform = 'none';
        }

        // Update dot states
        dots.forEach((dot, idx) => {
          const isActive = idx === index;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
      };

      // Button handlers
      if (prevBtn) {
        prevBtn.addEventListener('click', () => {
          updateSlide(this.currentSlide - 1);
          resetAutoAdvance();
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', () => {
          updateSlide(this.currentSlide + 1);
          resetAutoAdvance();
        });
      }

      // Dot click handlers
      dots.forEach((dot, idx) => {
        dot.addEventListener('click', () => {
          updateSlide(idx);
          resetAutoAdvance();
        });
      });

      // Touch swipe support
      let touchStartX = 0;
      let touchEndX = 0;

      track.addEventListener('touchstart', (e) => {
        touchStartX = e.changedTouches[0].screenX;
        stopAutoAdvance();
      }, { passive: true });

      track.addEventListener('touchend', (e) => {
        touchEndX = e.changedTouches[0].screenX;
        const diff = touchStartX - touchEndX;
        if (Math.abs(diff) > 40) {
          if (diff > 0) {
            updateSlide(this.currentSlide + 1);
          } else {
            updateSlide(this.currentSlide - 1);
          }
        }
        startAutoAdvance();
      }, { passive: true });

      // Auto-advance handled by shared carousel-autoplay.js (3 seconds)
      const startAutoAdvance = () => {};
      const stopAutoAdvance = () => {};
      const resetAutoAdvance = () => {};

      // Hover pause on desktop/tablet
      carousel.addEventListener('mouseenter', stopAutoAdvance);
      carousel.addEventListener('mouseleave', startAutoAdvance);

      // Window resize listener
      window.addEventListener('resize', utils.debounce(() => {
        if (window.innerWidth >= 990) {
          track.style.transform = 'none';
        } else {
          updateSlide(this.currentSlide);
        }
      }, 150));

      // Initial start
      startAutoAdvance();
    }
  };

  document.addEventListener('DOMContentLoaded', function() {
    CartDrawer.init();
    WhatsAppQuote.init();
    AddToCart.init();
    QuantitySelector.init();
    MegaMenu.init();
    MobileNav.init();
    FilterDrawer.init();
    CatalogManager.init();
    AnnouncementBar.init();
    StickyHeader.init();
    ProductGallery.init();
    VariantSelector.init();
    SearchOverlay.init();
    SeoContent.init();
    HeroSlider.init();
    ProductCarousel.init();
    Recommendations.init();
    FooterAccordion.init();
    Newsletter.init();
    LazyLoad.init();
    Accessibility.init();
    Addresses.init();
    ClientLogos.init();
    ShowroomCallout.init();
    HomeInteractivity.init();
    
    // Global defensive route guard: intercept legacy /catalog and /catalogue links
    document.addEventListener('click', function(e) {
      const link = e.target.closest('a');
      if (!link) return;
      const href = (link.getAttribute('href') || '').toLowerCase().trim();
      const pathname = (link.pathname || '').toLowerCase().replace(/\/+$/, '');
      if (pathname === '/catalog' || pathname === '/catalogue' || pathname === '/our-catalog' || href === '/catalog' || href === '/catalogue') {
        e.preventDefault();
        window.location.href = window.themeSettings?.allProductsUrl || '/collections/all';
      }
    });

    // Initial cart load for count
    if (document.querySelector('[data-cart-count]')) {
      OfFixCart.getCart().then(cart => {
        OfFixCart.updateCartCount(cart.item_count);
      });
    }
  });

})();

